module.exports = __webpack_public_path__ + "static/media/netflixClone.08fb4387.png";